export default {
  name: "add-sheba-card",
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shebaData: {
        address: "",
        name: ""
      },
      defaultData: {
        address: "",
        name: ""
      },
      shebaValidation: "",
      nameValidation: ""
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleDialog() {
      if (this.shebaData.name) {
        this.$emit(
          "confirmAddSheba",
          false,
          this.shebaData.address,
          this.shebaData.name,
          true
        );
        this.resetForm();
      } else {
        this.nameValidation = this.$t(
          "accountPage.bankInformation.shebaCards.modals.addCards.emptyTitleInputCard"
        );
      }

      // else {
      //   this.shebaValidation = this.$t(
      //     "accountPage.bankInformation.shebaCards.modals.addCards.invalidShebaInputCard"
      //   );
      // }
    },
    onClose() {
      this.$emit("closeDialog", false);
      this.resetForm();
    },
    resetForm() {
      setTimeout(() => {
        Object.assign(this.shebaData, this.defaultData);
      }, 1500);
      this.showTagInput = false;
    },
    checkShebaFormat() {
      this.shebaValidation = "";
      // if (
      //   sheba.indexOf("IR") !== 0 &&
      //   !sheba.includes("IR") &&
      //   sheba.length === 24
      // ) {
      //   this.shebaData.address = "IR" + sheba;
      // } else {
      //   this.shebaData.address = sheba;
      // }
      // console.log(this.shebaData.address);
      // if (!this.shebaData.address.match(this.data)) {
      //   this.shebaValidation = "شماره شبا وارد شده صحیح نیست.";
      // } else {
      //   this.shebaValidation = "";
      // }
      // if (!this.shebaData.address) {
      //   this.shebaValidation = "";
      // }
    },
    checkNameFormat() {
      this.nameValidation = "";
    }
  }
};
